import React, {PureComponent} from 'react'
import injectSheet, {withTheme} from 'react-jss'
import flow from 'lodash/flow'
import ArticleCard from './ArticleCard'
import ImageOrVideo from "../Widgets/ImageOrVideo"

class ArticleHeroGridCard extends PureComponent {
    _onCarouselClick = (e) => {
        e.stopPropagation();
        return false;
    }

    render() {
      const { classes, theme, article, ...rest} = this.props;
      const {link, horizontal_hero, video} = article

      return (
        <div className={classes.container}>
          <ImageOrVideo 
            key='image'
            className={classes.imageWrapper}
            imageClassName={classes.image}
            images={horizontal_hero}
            video={video}
            link={link}
            dataCy='heroImageContainer'
          />
          <div className={classes.cardWrapper} >
            <ArticleCard
              article={article}
              size='large'
              showArticleTime={true}
              image={null}
              className={classes}
              cardClassName={classes.card}
              fakeLink={true}
              clampSummary={3}
              {...rest}
            >
            </ArticleCard>
          </div>
        </div>
      )        
    }
}

export default flow([
  injectSheet( theme => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      marginBottom: theme.ds.spacing(4),
      [theme.breakpoint('laptop')]: {
        marginBottom: 0
      },
      '&:hover .hover': {
        textDecoration: 'none',
        transform: 'scale(1.03)',
        boxShadow: 'none'
      }
    },
    imageWrapper: {
      marginLeft: -theme.ds.spacing(2),
      marginBottom: -theme.ds.spacing(4),
      flex: '1 1 100%',
      [theme.breakpoint('tablet')]: {
        marginLeft: 0,
        flex: '1 1 100%'
      }
    },
    image: {
      height: '100%',
      [theme.breakpoint('laptop')]: {
        '&:before': {
          paddingTop: 0
        }  
      }
    },
    cardWrapper: {
      position: 'relative',
      padding: 0,
      marginRight: theme.ds.spacing(4)
    },
    cardContainer: {
      zIndex: theme.zIndex.card,
      width: '100%'
    },
    card: {
      borderRadius: [0, 0, 6, 6],
      height: '100%',
      margin: 0
    },
    productsContainer: {
      padding: theme.spacing.small,
      [theme.breakpoint('mobile')]: {
          padding: [theme.ds.spacing(6), 0, theme.ds.spacing(2)],
      },
      [theme.breakpoint('tablet')]: {
          padding: [theme.ds.spacing(6), theme.ds.spacing(4), 0],
      },
    },
    internalProductsContainer: {
      extend: '$productsContainer',
      padding: [theme.ds.spacing(2), 0, 0]
    },
    summary: {
      color: theme.colors.subTitle
    }
  })),
  withTheme
])(ArticleHeroGridCard)





// WEBPACK FOOTER //
// ./src/components/Card/ArticleHeroGridCard.js